import { useEffect, useState } from 'react';
import Slider, { SliderRail, SliderThumb, SliderTrack } from '@mui/material/Slider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';

const customTheme = createTheme({
  components: {
    MuiSlider: {
      styleOverrides: {
        root: {
          width: 300,
          height: 50,
        },
        thumb: {
          width: '24px',
          height: '24px',
          backgroundColor: 'blue',
        },
        rail: {
          height: '50px',
          borderRadius: 0,
          transform: 'translate(-10%, -50%)',
        },
      },
    },
  },
});

const customRail = (props: any) => (
  <SliderRail
    sx={{
      height: '50px',
      width: '375px',
      borderRadius: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    {...props}
  >
    <span>
      <Typography
        color="white"
      >
        退会する
      </Typography>
    </span>
  </SliderRail>
);

const customTrack = (props: any) => (
  <SliderTrack
    {...props}
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      height: '50px',
      borderRadius: 0,
    }}
  />
);

const customThumb = (props: any) => {
  const { children, ...other } = props;
  return (
    <SliderThumb sx={{ height: '50px', width: '75px', borderRadius: 0 }} {...other}>
      {children}
      <span className="text-white">&gt;</span>
    </SliderThumb>
  );
};

const CustomSlider = ({
  disabled,
  resetSlider,
  setIsCertainThatWantsToWithdraw,
  setResetSlider,
}: {
  disabled: boolean,
  resetSlider: boolean,
  setIsCertainThatWantsToWithdraw: (isCertain: boolean) => void,
  setResetSlider: (reset: boolean) => void,
}) => {
  // variables
  const [sliderValue, setSliderValue] = useState(0);

  // functions
  const handleSliderCommited = () => {
    if (sliderValue !== 100) {
      setSliderValue(0);
      setIsCertainThatWantsToWithdraw(false);
      return;
    }

    setIsCertainThatWantsToWithdraw(true);
  };

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setSliderValue(newValue as number);
  };

  // effects
  useEffect(() => {
    if (resetSlider) {
      setSliderValue(0);
      setIsCertainThatWantsToWithdraw(false);
    }

    setResetSlider(false);
  }, [resetSlider]);

  return (
    <ThemeProvider theme={customTheme}>
      <Slider
        disabled={disabled}
        value={sliderValue}
        min={0}
        max={100}
        orientation="horizontal"
        onChange={handleSliderChange}
        onChangeCommitted={handleSliderCommited}
        components={{
          Track: (props) => customTrack(props),
          Thumb: (props) => customThumb(props),
          Rail: (props) => customRail(props),
        }}
      />
    </ThemeProvider>
  );
};

export default CustomSlider;
